import { render, staticRenderFns } from "./ModalFavorisRecette.vue?vue&type=template&id=53c31cf9&"
import script from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"
export * from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c31cf9')) {
      api.createRecord('53c31cf9', component.options)
    } else {
      api.reload('53c31cf9', component.options)
    }
    module.hot.accept("./ModalFavorisRecette.vue?vue&type=template&id=53c31cf9&", function () {
      api.rerender('53c31cf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recettes/ModalFavorisRecette.vue"
export default component.exports